import React from 'react'
import ClimaOrganizacional from '../../../components/performance/ClimaOrganizacional'

export default function ClimaPage() {
  return (
    
            <ClimaOrganizacional />
          
  )
}
